import useApi from "../../../hooks/useApi";
import CommunicationHubApis from "../../../services/api/CommunicationHub";
import { useDispatch, useSelector } from "react-redux";
import { priority } from "../constants";
import {
  setOptions,
  setOptionsLoading,
} from "../../../store/actions/CommunicationHub";
import DriverServicesApi from "../../../services/api/DriverServices";
import { setExclusiveDriverServices } from "../../../store/actions/DriverServices";
import useMutation from "../../../hooks/useMutation";
import { useEffect } from "react";

const getOptions = async () => {
  const res = await CommunicationHubApis.getOptions();
  return {
    ...res,
    priority,
  };
};

const getExclusiveDriverServices = async () => {
  const res = await DriverServicesApi.exclusiveDriverService();
  return res;
};

const useOptions = () => {
  const { options, loading } = useSelector((store) => store.CommunicationHub);
  const { exclusiveDriverServices = [] } = useSelector(
    (state) => state.DriverServices
  );
  const driver_services = exclusiveDriverServices?.map((item) => ({
    label: item.name,
    value: item.id,
  }));

  const dispatch = useDispatch();
  const { mutate, isPending, error } = useMutation(async () => {
    try {
      dispatch(setOptionsLoading(true));
      const options = await getOptions();
      dispatch(setOptions(options));
      dispatch(setOptionsLoading(false));
      const driverServices = await getExclusiveDriverServices();
      dispatch(
        setExclusiveDriverServices(driverServices?.driver_services ?? [])
      );
    } catch (err) {
      throw err;
    } finally {
      dispatch(setOptionsLoading(false));
    }
  });

  useEffect(() => {
    if (!loading && options === null) {
      mutate();
    }
  }, []);

  return {
    options: { ...options, driver_services },
    error,
    isLoading: loading,
  };
};

export default useOptions;
